import React, { createContext, useState, useContext, useEffect } from 'react';

// Create context
const SearchFilesContext = createContext();

// Create provider component
export function SearchFilesProvider({ children }) {
  // Maintain separate selections for each page type
  const [homePageFiles, setHomePageFiles] = useState(new Set(['CivilCode.txt', 'CivilPro.txt']));
  const [explanationPageFiles, setExplanationPageFiles] = useState(new Set(['CivilCodeExplain.txt']));
  const [libraryPageFiles, setLibraryPageFiles] = useState(new Set(['SampleResearch.txt']));
  
  // Maintain search state for Home page
  const [homeSearchState, setHomeSearchState] = useState({
    query: '',
    submittedQuery: '',
    results: [],
    attempted: false,
    data: [],
    scrollPosition: 0 
  });

  // Maintain search state for Explanation page
  const [explanationSearchState, setExplanationSearchState] = useState({
    query: '',
    submittedQuery: '',
    results: [],
    attempted: false,
    scrollPosition: 0
  });

  // Maintain search state for Library page
  const [librarySearchState, setLibrarySearchState] = useState({
    query: '',
    submittedQuery: '',
    results: [],
    attempted: false,
    data: [],
    scrollPosition: 0
  });

  const [searchCount, setSearchCount] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem('searchCount');
      return stored ? Number(stored) : 0;
    }
    return 0;
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('searchCount', String(searchCount));
    }
  }, [searchCount]);

  // Update function based on page type
  const updateSelectedFiles = (files, pageType) => {
    if (pageType === 'explanation') {
      setExplanationPageFiles(new Set(files));
    } else if (pageType === 'library') {
      setLibraryPageFiles(files);
    } else {
      setHomePageFiles(files);
    }
  };
  
  // Get files based on page type
  const getSelectedFiles = (pageType) => {
    if (pageType === 'explanation') return explanationPageFiles;
    if (pageType === 'library') return libraryPageFiles;
    return homePageFiles;
  };
  
  return (
    <SearchFilesContext.Provider value={{ 
      updateSelectedFiles, 
      getSelectedFiles,
      homeSearchState,
      setHomeSearchState,
      explanationSearchState,
      setExplanationSearchState,
      librarySearchState,
      setLibrarySearchState,
      searchCount,
      setSearchCount
    }}>
      {children}
    </SearchFilesContext.Provider>
  );
}

// Custom hook to use the context
export function useSearchFiles() {
  return useContext(SearchFilesContext);
}
